import React from "react";
import classNames from "classnames";

import { useModal } from "@root/client/modal";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { Props } from "./types";
import styles from "./styles.scss";

function NameEditionForm({ event }: Props) {
  const [name, setName] = React.useState(event.name);
  const { pushView } = useModal();
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    setName(event.name);
  }, [event.name]);

  // useMessage(
  //   (message) =>
  //     message.type === events.editEventFailed &&
  //     event.uuid === message.data.event.uuid &&
  //     setName(event.name)
  // );

  return (
    <VisibilitySwitch
      renderChildren={(isVisible, show, hide) => (
        <div
          className={classNames(styles.nameEditionForm, {
            [styles.edition]: isVisible,
          })}
        >
          <form
            className={styles.form}
            onSubmit={(e) => {
              e.preventDefault();
              hide();
            }}
          >
            <input
              ref={inputRef}
              className={styles.input}
              value={name}
              onBlur={() => {
                hide();
                setName(event.name);
              }}
              onChange={({ target }) => setName(target.value)}
            />
          </form>
          <div className={styles.name}>
            <h3>{event.name}</h3>
            {/*<div*/}
            {/*  onClick={(e) => {*/}
            {/*    e.stopPropagation();*/}
            {/*    show();*/}
            {/*    setTimeout(() => {*/}
            {/*      inputRef.current && inputRef.current.focus();*/}
            {/*    });*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <EditIcon*/}
            {/*    className={styles.icon}*/}
            {/*    style={{ color: event.status.color }}*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
        </div>
      )}
    />
  );
}

export { NameEditionForm };
